// HIPAA F-11: wipe patient data the browser kept for convenience when a session ends.
// Unsynced offline work (queued notes/actions) is kept until it syncs so nothing is lost.
const PHI_KEY_PATTERNS = [
  /^recent_/, /^favorites_/, /^defense_packages_/, /^compliance_events_/, /^cert_progress_/,
  /^referrals_/, /^hospiceguard_edit_draft_/, /draft/i, /^recertificationCTI$/, /^linkedF2F$/,
  /^linkedCTI$/, /^linkedAuditForCoaching$/, /^commandcenter_favorites$/, /^__hg_unread_compliance_alerts$/,
];
const CACHE_DB = "hospiceguard_offline";
const CACHE_STORES = ["audits", "calendar_events", "user_data", "templates", "sync_meta"];

const clearStores = (dbName, stores) =>
  new Promise((resolve) => {
    try {
      const open = indexedDB.open(dbName);
      open.onerror = () => resolve();
      open.onupgradeneeded = () => open.transaction.abort();
      open.onsuccess = () => {
        const db = open.result;
        const present = stores.filter((s) => db.objectStoreNames.contains(s));
        if (!present.length) { db.close(); resolve(); return; }
        const tx = db.transaction(present, "readwrite");
        present.forEach((s) => tx.objectStore(s).clear());
        tx.oncomplete = tx.onerror = tx.onabort = () => { db.close(); resolve(); };
      };
    } catch (e) {
      resolve();
    }
  });

export const clearBrowserPhi = async () => {
  try {
    Object.keys(localStorage)
      .filter((k) => PHI_KEY_PATTERNS.some((re) => re.test(k)))
      .forEach((k) => localStorage.removeItem(k));
    sessionStorage.clear();
  } catch (e) {
    // storage unavailable (private mode) — nothing to clear
  }
  if ("indexedDB" in window) await clearStores(CACHE_DB, CACHE_STORES);
};
